import React from 'react';
import { TCN } from '../ui-kit/tokens';

/**
 * TCN TopBar — large title style iOS.
 * Mobile pattern: 56px row with leading slot (avatar) / title / trailing slot (icons),
 * optional subtitle line below.
 *
 * Props:
 *  - leading: ReactNode
 *  - trailing: ReactNode
 *  - title: string
 *  - subtitle: string (optional)
 *  - largeTitle: boolean — render iOS large title (28px) below the chrome row (default false)
 */
const TopBar = ({
  leading,
  trailing,
  title,
  subtitle,
  largeTitle = false,
  className = '',
  style,
}) => {
  return (
    <header
      className={className}
      style={{
        padding: '8px 16px 12px',
        background: TCN.bg,
        ...style,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          minHeight: 44,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          {leading}
          {!largeTitle && title && (
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  color: TCN.text,
                  letterSpacing: '-0.02em',
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {title}
              </div>
              {subtitle && (
                <div
                  style={{
                    fontSize: 12,
                    color: TCN.textDim,
                    marginTop: 1,
                  }}
                >
                  {subtitle}
                </div>
              )}
            </div>
          )}
        </div>
        {trailing && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {trailing}
          </div>
        )}
      </div>

      {largeTitle && title && (
        <div style={{ marginTop: 8 }}>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: TCN.text,
              letterSpacing: '-0.04em',
              lineHeight: 1.1,
              margin: 0,
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <div
              style={{
                fontSize: 13,
                color: TCN.textDim,
                marginTop: 4,
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default TopBar;
